import { render } from "./CustomerDiscountGroupProductsModal.html?vue&type=template&id=de4c05ec&scoped=true"
import script from "./CustomerDiscountGroupProductsModal.js?vue&type=script&lang=js"
export * from "./CustomerDiscountGroupProductsModal.js?vue&type=script&lang=js"

import "./CustomerDiscountGroupProductsModal.css?vue&type=style&index=0&id=de4c05ec&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4c05ec"]])

export default __exports__